import Vue from 'vue';

Vue.filter('formatMobile', function (val) {
  if (val) {
    return val.substring(0, 3) + '****' + val.substring(val.length - 4, val.length);
  }
  return ''
});

